// Helper functions for PGN processing

// Helper function to parse PGN moves into array
export const parsePGN = (pgn) => {
  return (pgn || '')
    .replace(/\{[^}]*\}/g, ' ')                     // Remove comments
    .replace(/\d+\.(\.\.)?/g, ' ')                  // Remove move numbers (1. and 1...)
    .replace(/(1-0|0-1|1\/2-1\/2|\*)\s*$/, ' ')     // Remove result
    .trim()
    .split(/\s+/)
    .filter(move => move.length > 0);
};

// Helper function to process a line (variation)
export const processLine = (line, playerColor) => {
  const moves = parsePGN(line.pgn);
  const playerMoves = playerColor === 'white' 
    ? moves.map((_, index) => index).filter(index => index % 2 === 0)
    : moves.map((_, index) => index).filter(index => index % 2 === 1);
  
  return {
    ...line,
    moves,
    playerMoves
  };
};

// Process all lines for an opening
export const processOpeningLines = (opening) => {
  const processedLines = opening.lines.map(line => processLine(line, opening.playerColor));
  
  return {
    ...opening,
    lines: processedLines,
    // Set default to first line for backward compatibility
    moves: processedLines[0]?.moves || [],
    playerMoves: processedLines[0]?.playerMoves || []
  };
};